const h = (n, l) => (c, s, t) => {
  let o = Array.from({ length: c }, (f, m) => n(m));
  l && (o = o.filter(l));
  const i = o.length;
  s = s ?? 0, t = t ?? i;
  const e = o.slice(s * t, (s + 1) * t), r = Math.ceil(i / t) || 0;
  return {
    totalEntries: i,
    totalPages: r,
    page: s,
    perPage: t,
    items: e
  };
};
export {
  h as createMockListResponse
};
//# sourceMappingURL=CreateMockListResponse.js.map
